import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export default function MultiCheckbox({ options, values, onChange, testidPrefix }) {
  const toggle = (val) => {
    if (values.includes(val)) onChange(values.filter((v) => v !== val));
    else onChange([...values, val]);
  };
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {options.map((opt) => {
        const value = typeof opt === "string" ? opt : opt.value;
        const label = typeof opt === "string" ? opt : opt.label;
        const checked = values.includes(value);
        return (
          <label
            key={value}
            className={`flex items-center gap-3 border rounded-lg px-4 py-3 cursor-pointer transition-colors ${
              checked ? "border-neutral-900 bg-neutral-50" : "border-neutral-200 hover:border-neutral-400"
            }`}
          >
            <Checkbox
              checked={checked}
              onCheckedChange={() => toggle(value)}
              data-testid={`${testidPrefix}-${value}`}
            />
            <span className="text-sm">{label}</span>
          </label>
        );
      })}
    </div>
  );
}
